import { Component, Input, OnInit } from '@angular/core';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { NgbModal, NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { ScreeningAdditionalData, TriggerRecordTogglePayload, ScreeningLight } from 'src/app/models/screeningInvite';
import { take, tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { VendorResponseTypes, SearchPackage } from 'src/app/packages-module/models/searchPackage';
import { Subject } from 'rxjs';
import { CriminalRecord } from 'src/app/models/ApplicantDataResponses/ApplicantDataResponses';
import { ScreeningService } from '../../services/screening.service';
import { ClientPackagePricing } from 'src/app/packages-module/models/clientPackagePrice';
import { PropertyService } from 'src/app/property-module/services/property.service';
import { ClientLocation } from 'src/app/clients-module/models/clientLocation';
import { Address } from 'src/app/models/Address';

@Component({
  selector: 'app-excludable-records-dialog',
  templateUrl: './excludable-records-dialog.component.html',
  styleUrls: ['./excludable-records-dialog.component.less']
})
export class ExcludableRecordsDialogComponent implements OnInit {
  def: NgbNav
  activeId: number;
  @Input() pkg: ScreeningAdditionalData;
  @Input() clientPricingModel : ClientPackagePricing;
  @Input() locationId : number;
  @Input() appliedPackage : SearchPackage;
  @Input() _screening : ScreeningLight; //NOTE! this is an init'd screening light, so it has the prop data on it; the getter below pulls the shallow copy

  constructor(public appData: ApplicantDataService, public modalService: NgbModal, public toast: ToastrService, public screening : ScreeningService, 
    public propSvc : PropertyService) 
    {

    }
  
  ngOnInit(): void {
    console.info(this.pkg);

    this.appData.GetAddressStatesAndCounties(this.screeningToEdit.id);
  }
  public get screeningToEdit() : ScreeningLight {
    return this.screening.screenings[0];
  }

  excludeAllAliases : Subject<boolean> = new Subject<boolean>();
  excludeAllAddresses : Subject<boolean> = new Subject<boolean>();

  toggleSelectedAliases(include : boolean){
    this.excludeAllAliases.next(include);
  }

  toggleSelectedAddys(include : boolean){
    this.excludeAllAddresses.next(include);
  }

  excludeAll() {
    let pld = new TriggerRecordTogglePayload();
    pld.recordsIncluded = false;
    this.runtoggles(pld);
  }

  includeAll() {
    let pld = new TriggerRecordTogglePayload();
    pld.recordsIncluded = true;
    this.runtoggles(pld);
  }

  runtoggles(pld: TriggerRecordTogglePayload) {
    pld.searchEntryId = this.pkg.searchEntryId;
    pld.searchType = this.pkg.searchTypeEnum;
    pld.clientId = this.pkg.clientId;
    pld.screeningId = this.pkg.screeningId;
    if (this.pkg.searchTypeEnum == VendorResponseTypes.Eviction) pld.recordIds = this.appData.evictionRecords.map(ev => { return ev.evictionRecordId });
    if (this.pkg.searchTypeEnum == VendorResponseTypes.Criminal) pld.recordIds = this.appData._criminalRecords.map(ev => { return ev.offenseId });
    this.appData.ToggleRecord2([pld]).pipe(take(1), tap(_ => {
      console.info(_);
    })).subscribe(() => {
      this.toast.success(`Records Toggled Successfully`);
      if (this.pkg.searchTypeEnum == VendorResponseTypes.Eviction) this.appData.evictionRecords.forEach(ev => { ev.excludeFromReport = !pld.recordsIncluded });
      if (this.pkg.searchTypeEnum == VendorResponseTypes.Criminal) this.appData._criminalRecords.forEach(ev => { ev.excludeFromReport = !pld.recordsIncluded });
    },
      () => { this.toast.error(`Records Toggle Failed`); });
  }

 

}
